(function () {
  function isMobile() {
    return window.matchMedia('(max-width: 768px)').matches;
  }

  function setActiveStep(root, index) {
    var triggers = root.querySelectorAll('[data-step-trigger]');
    var panels = root.querySelectorAll('[data-step-panel]');

    triggers.forEach(function (trigger) {
      var triggerIndex = parseInt(trigger.getAttribute('data-step-trigger'), 10);
      var isActive = triggerIndex === index;
      var isIconBtn = trigger.classList.contains('section-open-eh-stu-step__icon-btn');
      var isLabelBtn = trigger.classList.contains('section-open-eh-stu-step__label-btn');

      if (isIconBtn || isLabelBtn) {
        trigger.classList.toggle('is-active', isActive);
      }

      if (isIconBtn) {
        trigger.setAttribute('aria-selected', isActive ? 'true' : 'false');
      }
    });

    panels.forEach(function (panel) {
      var panelIndex = parseInt(panel.getAttribute('data-step-panel'), 10);
      var isActive = panelIndex === index;

      panel.classList.toggle('is-active', isActive);

      if (isMobile()) {
        if (isActive) {
          panel.removeAttribute('hidden');
        } else {
          panel.setAttribute('hidden', '');
        }
      } else {
        panel.removeAttribute('hidden');
      }
    });
  }

  function initRoot(root) {
    if (!root || root.dataset.stepInitialized === 'true') return;
    root.dataset.stepInitialized = 'true';

    root.querySelectorAll('[data-step-trigger]').forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        if (!isMobile() && trigger.classList.contains('section-open-eh-stu-step__icon-btn')) {
          return;
        }

        var index = parseInt(trigger.getAttribute('data-step-trigger'), 10);
        if (Number.isNaN(index)) return;
        setActiveStep(root, index);
      });
    });

    var onResize = function () {
      var activePanel = root.querySelector('[data-step-panel].is-active');
      var index = activePanel
        ? parseInt(activePanel.getAttribute('data-step-panel'), 10)
        : 0;
      setActiveStep(root, index);
    };

    window.addEventListener('resize', onResize);
    root._stepOnResize = onResize;

    setActiveStep(root, 0);
  }

  function destroyRoot(root) {
    if (!root) return;

    if (root._stepOnResize) {
      window.removeEventListener('resize', root._stepOnResize);
      delete root._stepOnResize;
    }

    delete root.dataset.stepInitialized;
  }

  function initAll() {
    document.querySelectorAll('[data-oeh-stu-step-root]').forEach(initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-oeh-stu-step-root]');
    if (!root) return;
    destroyRoot(root);
    initRoot(root);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var root = event.target.querySelector('[data-oeh-stu-step-root]');
    if (!root) return;
    destroyRoot(root);
  });
})();
